/**
 * AlertTypeBadge — displays AlertSubType as a styled badge tag
 * whose popover (hover, focus or tap) shows the AlertType (category).
 */

import InfoPopover from '../../../../components/v2/InfoPopover.jsx';

const AlertTypeBadge = ({ alertType, alertSubType }) => {
    if (!alertSubType && !alertType) return <span>—</span>;

    const tag = <span className="na-type-tag">{alertSubType || alertType || '—'}</span>;
    if (!alertType) return tag;

    return (
        <InfoPopover marker="none" heading="Category" body={alertType} maxWidth={240}>
            {tag}
        </InfoPopover>
    );
};

export default AlertTypeBadge;
